







import Vue from 'vue'
import { Amiibo } from '../service'

/**
 * Record displayed in lists.
 */
export default Vue.extend({
  name: 'Record',
  props: [
    /**
     * Id of the item.
     */
    'id',
    /**
     * Image of the item.
     */
    'image',
    /**
     * Name of the item.
     */
    'name'
  ]
})
